import { useEffect, useState } from 'react';

const useStatusEditProjectForTable = (
    gantEditScheduleItem: {
        userId: string;
        projectId: string;
    }[],
    authorId: string,
    projectId?: string,
) => {
    const [listEditingProjectId, setListEditingProjectId] = useState<Set<string>>();

    useEffect(() => {
        setListEditingProjectId(
            new Set(
                (gantEditScheduleItem || []).filter((item) => item.userId === authorId).map((item) => item.projectId),
            ),
        );
    }, [authorId, gantEditScheduleItem]);

    return listEditingProjectId?.has(projectId ?? '') || false;
};

export default useStatusEditProjectForTable;
